const isScrollable = (el) => {
  const div = el;
  return div.scrollHeight>div.clientHeight;
};

export default isScrollable;
